export class AggregationType {
  name: string = '';
  label: string = '';
  format: string = '';
  hc_format: string = '';
  default?: string = '';

  constructor(name: string, label: string, format: string, hc_format: string, defaultValue?: string) {
    this.name = name;
    this.label = label;
    this.format = format;
    this.hc_format = hc_format;
    this.default = defaultValue;
  }
}
